import { Checkbox, InfoTipIcon, RevelioTooltip } from '@revelio/ui';

import { ADAPTIVE_MAP } from '../../hooks/useAdaptiveChartType';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import styles from './adaptive-chart-selector.module.css';

const ADAPTIVE_LABELS: Record<string, string> = {
  metric: 'Single-entity metric',
  treemap: 'Single-entity treemap',
  chord: 'Multi-entity chord',
};

const ADAPTIVE_TOOLTIPS: Record<string, string> = {
  metric: 'Show single-metric view when one entity is selected.',
  treemap: 'Show treemap when one entity is selected.',
  chord: 'Switch to a chord diagram when three or more entities are selected.',
};

type AdaptiveChartSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const AdaptiveChartSelector = ({
  item,
  isDisabled = false,
}: AdaptiveChartSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const id = item?.id;
  const chartType = item?.plot?.chartType;
  const adaptiveTarget = chartType ? ADAPTIVE_MAP[chartType] : undefined;
  const isChecked = item?.plot?.adaptive ?? false;

  if (!adaptiveTarget) {
    return null;
  }

  const label = ADAPTIVE_LABELS[adaptiveTarget];
  const tooltipLabel = ADAPTIVE_TOOLTIPS[adaptiveTarget];

  return (
    <div className={styles.checkboxRow}>
      <Checkbox
        labelSize="sm"
        checked={isChecked}
        disabled={isDisabled}
        onChange={(e) => {
          if (id) {
            dispatch({
              type: 'UPDATE_ITEM_ADAPTIVE',
              payload: { id, adaptive: e.target.checked },
            });
          }
        }}
      >
        {label}
      </Checkbox>
      <RevelioTooltip label={tooltipLabel} placement="top">
        <span>
          <InfoTipIcon size={14} aria-label="Adaptive chart info" />
        </span>
      </RevelioTooltip>
    </div>
  );
};
